import React from "react";

import "./FloatButton.styles.css";

export const FloatButton = () => {
  return (
    <div className="float__button">
      <div className="float__button--container">
        <div>
          <div className="float__button--text">
            <p>出品</p>
          </div>
          <div className="float__button--icon">
            <svg width="18" height="16" viewBox="0 0 18 16">
              <path d="M6.3 0L4.653 1.778H1.8c-.99 0-1.8.8-1.8 1.778v10.666C0 15.2.81 16 1.8 16h14.4c.99 0 1.8-.8 1.8-1.778V3.556c0-.978-.81-1.778-1.8-1.778h-2.853L11.7 0H6.3zM9 13.333c-2.484 0-4.5-1.99-4.5-4.444 0-2.453 2.016-4.445 4.5-4.445s4.5 1.992 4.5 4.445c0 2.453-2.016 4.444-4.5 4.444zm0-1.6c1.59 0 2.88-1.273 2.88-2.844S10.59 6.044 9 6.044c-1.59 0-2.88 1.274-2.88 2.845 0 1.57 1.29 2.844 2.88 2.844z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
